<template>

    <div class="lc_splashContainer TQ_bg_purple TQ_height_100vh TQ_animation_fadeOut_3500ms"
         :style="{'zIndex': gv_zIndex.app_splashScreen}"
         v-if="co_showSplashScreen_b">

        <div class="TQ_centerAbsolute">
            <full-logo class="lc_logo  TQ_maxWidth_200px TQ_width_100p"/>
            <div class="lc_url TQ_animation_show_700ms_w1500ms TQ_textColor_white TQ_center ">
                TravelQuest.xyz
            </div>
        </div>
    </div>
</template>

<script>
    import FullLogo from "../../components/a_smartIcons/si_fullLogo";
    import {gv_zIndex} from "@/scripts/S_GlobalVar";
    import {date_setTimeout} from "@/scripts/S_Date";
    import {enum_moveToOptions} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "C_App_SplashScreen",
        components: {FullLogo},
        data(){
            return {
                showSplashScreen_b  : true,
                gv_zIndex           : gv_zIndex,
            }
        },
        computed:{
            co_showSplashScreen_b() {
                let path_s = window.location.href.toLowerCase()

                return this.showSplashScreen_b
                    && !path_s.includes(enum_moveToOptions.standAlong_paymentFailed)
                    && !path_s.includes(enum_moveToOptions.standAlong_paymentSuccess)
                    && !path_s.includes(enum_moveToOptions.player_store_whiteLabel)
            }
        },
        created(){
            date_setTimeout(() => {
                this.showSplashScreen_b = false
            },3500, this.$options.name)
        }
    }
</script>

<style scoped lang="scss">

    /* splash screen*/
    .lc_splashContainer {
        position: fixed;
        top: 0;
        height: 100vh;
        width: 100vw;

        .lc_logo{
            border-radius: 20px;
        }

        .lc_url {
            letter-spacing: 2px;
            font-size: 20px;
        }


    }


</style>